<template>
  <div class="entry-platform-container">
    <div class="slider_container">
      <el-carousel :height="sliderStyle.height" indicator-position="none">
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <div class="slider-wrapper">
            <img :src="baseUrl + item.imageUrl" class="slider_img" @click="turnToTarget(item)">
            <div class="day-counter">
              <span class="day-number">{{ getDayCount }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
        <section class="about-area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="about-title" style="text-align: left;">
                            <p class="title">永不落幕的线上线下交易中心</p>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="about-image">
                            <img v-if="companyDetailsData.bannerImages" :src="companyDetailsData.bannerImages" alt="公司图片">
                            <img v-else :src="require('../assets/test2.png')" alt="公司图片">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="about-content">
                            <div class="text">
                                <p v-if="companyDetailsData.companyIntroduction">{{ companyDetailsData.companyIntroduction }}</p>
                                <p v-else>国际工业品展示交易中心，作为一个集展示、交易、交流、仓储等功能于一体的综合性平台，始终致力于为国内外工业品生产商、采购商、经销商提供一个高效、便捷的展示与交易平台。其独特的仓储式展示定位，为客户提供一个多功能立体空间,既能展示产品，又具备储存展示设施、展示样品和展销货物的多重功能。因际工业品展示交易中心在保税区内，国外进口产品无需报关，即可在展示交易中心进行展示，极大地降低了企业的综合成本。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="about-area">
          <div class="container">
            <div>十二季主题展</div>
            <div class="theme-exhibition">
              <div class="theme-card" v-for="(item, index) in imageDatas" :key="index" @click="handleCardClick(item)">
                <div class="theme-card-inner">
                  <img :src="baseUrl + (item.imageUrl ? item.imageUrl.split(',')[0] : '')" alt="主题展图片" class="theme-image">
                  <div class="theme-overlay">{{ item.name }}</div>
                  <!-- <div class="theme-info">
                    <div class="theme-date">{{ item.name }}</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </section>
    </div>
  </div>
</template>
<script>
import { GetBannerList, ShowPicture  } from '../api/home/api'
import { baseUrl } from '../utils'
import {GetCompanyInfo} from "@/api/pdf/api";
export default {
  name: 'Exhibition',
  data() {
    return {
      dialogVisible: false,
      baseUrl,
      getCoding: true,
      codeTime: 60,
      sliders: [],
      sliderStyle: {},
      formData: {
        userName: undefined,
        email: undefined,
        mobile: undefined,
        code: undefined,
        field105: undefined,
        name: undefined,
        privince: undefined,
        city: undefined,
        district: undefined,
      },
      privinceOptions: [],
      cityOptions: [],
      districtOptions: [],
      imageDatas: [],
      companyDetailsData: {}
    }
  },
  methods: {
    entrySuccess() {
      window.location.reload();
    },
    proviceChage() {
      this.getCityOptions();
    },
    cityChage() {
      this.getDistrictOptions();
    },
    ticketing() {
      this.timer = setInterval(() => {
        if(this.codeTime === 1) {
          this.getCoding = true;
          this.codeTime = 60;
          clearInterval(this.timer);
        }
        this.codeTime = --this.codeTime;
      }, 1000);
    },
    getBanner() {
      GetBannerList().then(data => {
        if(data && data.length) {
          data.forEach(item => {
            item.targetPath = '/EntryPlatform';
          })
          this.sliders = [...data];
          // 获取图片高度
          if(data[0] && data[0].imageUrl) {
            this.loadImg(this.baseUrl + this.sliders[0].imageUrl, () => {
              this.$nextTick(() => {
                const ele = document.querySelector('.slider_img')
                ele && (this.sliderStyle = {...getComputedStyle(document.querySelector('.slider_img'), null)})
              })
            });
          }
        }
      })
    },
    getShowPicture() {
      ShowPicture().then(data => {
        this.imageDatas = data;
      })
    },
    loadImg(url, cb) {
      const oImg = new Image();
      oImg.onload = () => {
        cb && cb();
      };
      oImg.src = url;
    },
    turnToTarget(item) {
      this.$router.push(item.targetPath)
      // 跳转到展厅页面，暂时注释掉
      // this.$router.push({path: "/exhibitionHall"})
    },
      handleCardClick(item) {
        // this.$router.push({ path: '/exhibitionPic', query: { pictureShowId: item.id} });
        this.$router.push({ path: '/ProductPic', query: { pictureShowId: item.id} });
      },
      computedById() {
          GetCompanyInfo({
              'companyId': '961'
          }).then(data => {
              this.companyDetailsData = data;
              // 检查banner图片是否可访问
              if (data.bannerImages) {
                  const img = new Image();
                  img.onerror = () => {
                      that.companyDetailsData.bannerImages = '';
                  };
                  img.src = this.baseUrl + data.bannerImages;
              }

          })
      }
  },
  mounted() {
    this.getBanner();
    this.getShowPicture();
    this.computedById();
  },
  computed: {
    getDayCount() {
      const startDate = new Date('2024-10-15');
      const today = new Date();
      const diffTime = Math.abs(today - startDate);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 计算每月闭门日
      const months = Math.floor(diffDays / 30);
      diffDays -= months * 2;

      // 计算春节等公共假期
      const year = today.getFullYear();
      // 根据农历计算春节日期
      const springFestival = getLunarNewYear(year);
      function getLunarNewYear(year) {
        // 2024年春节是2月10日
        if (year === 2024) return new Date(2024, 1, 10);
        // 2025年春节是1月29日
        if (year === 2025) return new Date(2025, 0, 29);
        // 其他年份默认2月1日
        return new Date(year, 1, 1);
      }
      if (today >= springFestival) {
        diffDays -= 11;
      }

      return diffDays;
    }
  },
}
</script>
<style scoped>
.entry-platform-container {
  width: 100%;
  background-color: #fff;
  color: #000;
  font-family: Microsoft YaHei;
}
.slider_container {
  padding: 10px 0;
}
.platform-info {
  display: flex;
  max-width: 1620px;
  margin: 20px auto 60px;
}
.platform-input-info {
  width: 520px;
}
.platform-input-info h3 {
  height: 30px;
  line-height: 30px;
  font-size: 26px;
  padding: 0 0 16px 40px;
}
.platform-input-info h4 {
  font-size: 22px;
  height: 36px;
  line-height: 36px;
  padding-left: 40px;
}
.entry-platform-container >>> .el-row {
  margin: 20px;
}
.entry-platform-container >>> .el-col {
  padding: 0 !important;
  display: flex;
  position: relative;
  z-index: 99;
}
.entry-platform-container >>> .el-form-item {
  margin-bottom: 30px;
}
.entry-platform-container >>> .el-form-item__label {
  color: #333;
}
.entry-platform-container >>> .el-input__inner {
  /* border-color: #333; */
  /* border-radius: 0; */
}
.get-code-btn {
  margin-left: 10px;
  flex: 0 !important;
}
.get-code-btn >>> .el-form-item__content {
  margin-left: 0 !important;
}
.get-code-btn >>> .el-button--medium {
  padding: 10px !important;
}
.code-item >>> .el-form-item {
  flex: 1;
}
.platform-desc {
  flex: 1;
  margin-left: 100px;
  background-color: rgba(0, 0, 0, .03);
  background: url('../assets/other/add_bg.png') right bottom no-repeat;
  padding: 0 0 520px 134px;
  background-size: cover;
}
.submit {
  width: 100%;
  background-color: #205eab !important;
  border: none !important;
}
.platform-desc-info h3 {
  font-size: 26px;
  height: 30px;
  line-height: 30px;
  padding: 30px 0;
}
.platform-desc-info p {
  line-height: 34px;
  padding-left: 50px;
  font-size: 18px;
  color: #011627;
}
.platform-desc-info-text {
  font-size: 14px;
  color: #707171;
  line-height: 26px;
  padding: 10px 50px 0;
}
.platform-desc-info-text span {
  display: block;
  padding: 10px 0;
  width: 500px;
}
.slider_img {
  width: 100%;
}
.day-counter {
  position: absolute;
  top: 185px;
  left: 905px;
  transform: translate(-50%, -50%);
  /*background: rgba(255, 255, 255, 0.9);*/
  padding: 10px 15px;
  border-radius: 4px;
  text-align: center;
}

.day-number {
  font-size: 30px;
  font-weight: bold;
  color: #394556;
  font-family: Microsoft YaHei;
}
.mobile_code_button {
  background-color: #205eab !important;
  border: none !important;
}


/* 关于我们部分优化后的样式 */
.about-area {
    padding: 80px 0;
    background-color: #fff;
}

.category-section {
    padding: 60px 0;
    background-color: #f8f8f8;
}

.container {
    /* 已有样式保持不变 */
}

.category-list {
    display: block; /* 改为块级布局 */
}

.category-item {
    width: 100%;
    margin-bottom: 30px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.category-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.container {
    width: 100%;
    max-width: 1500px;  /* 限制最大宽度 */
    margin: 0 auto;
    padding: 0 30px;    /* 增加两侧内边距 */
}

/* 调整行间距 */
.row.align-items-center {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    margin: 0 -15px;
    gap: 30px;          /* 增加图片和文字间距 */
}

.col-lg-6 {
    flex: 0 0 calc(50% - 15px); /* 减去间距的一半 */
    max-width: calc(50% - 15px);
    padding: 0 15px;
    box-sizing: border-box;
}

.about-title .title {
    font-size: 28px;
    /*font-weight: bold;*/
    margin-bottom: 40px;
    color: #333;
    text-align: left;  /* 改为左对齐 */
    position: relative;
}

.about-title .title::after {
    content: '';
    position: absolute;
    left: 0;  /* 改为从左侧开始 */
    bottom: -10px;
    transform: none;  /* 移除居中变换 */
    width: 80px;
    height: 3px;
    /* background: #1890ff; */
}

/* 确保左右布局的关键样式 */
.row.align-items-center {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    margin: 0 -15px;
}

.col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 15px;
    box-sizing: border-box;
}

.about-image {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(0,0,0,0.1);
    height: 100%;
    margin-left: 45px;
}

.about-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: all 0.3s;
}

.about-content {
    padding-left: 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    padding-right: 30px;
}

.about-content .text {
    line-height: 1.8;
    color: #666;
    font-size: 20px;
    text-align: justify;
    text-indent: 2em;
}

.about-content .text p {
    margin-bottom: 1em;
}
/* 十二季主题展样式 */
.theme-exhibition {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* 同步更新网格列宽 */
  gap: 26px;
  justify-content: center;
  padding: 20px 0;
}

.theme-card {
  width: 350px;
  height: 524px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.theme-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.theme-card-inner {
  width: 100%;
  height: 100%;
  background-color: #0a4da2;
  overflow: hidden;
  position: relative;
}

.theme-image {
  width: 350px;  /* 增大宽度，保持比例 */
  height: 524px; /* 按278:416比例计算得出 (350×416÷278≈524) */
  object-fit: cover;
  transition: all 0.5s ease;
}

.theme-card:hover .theme-image {
  filter: blur(5px); /* 高斯模糊效果 */
}

/* 新增文字覆盖层样式 */
.theme-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none; /* 确保点击事件穿透到卡片 */
  width: 80%;
}

.theme-card:hover .theme-overlay {
  opacity: 1; /* 悬停时显示文字 */
}

.theme-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  color: white;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  transition: opacity 0.3s ease;
}

/* 修改原有悬停效果，移除不需要的变换 */
.theme-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.theme-title {
  font-size: 24px;
  margin-bottom: 10px;
}

.theme-desc {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.theme-card:hover .theme-desc {
  opacity: 1;
  transform: translateY(0);
}

.theme-date {
  font-size: 14px;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease 0.1s;
}

.theme-card:hover .theme-date {
  opacity: 1;
  transform: translateY(0);
}
</style>
